export const LOCAL_STORAGE_TOKEN_KEY = 'token';
export const LOCAL_STORAGE_SKIN = 'skin';
export const LOCAL_STORAGE_SDP = 'sdp';
export const LOCAL_STORAGE_CUSTOM_SKIN = 'customSkin';
